export enum AmenityKeys {
  '24-hour-check-in' = '24-hour-check-in',
  '24-hour-front-desk' = '24-hour-front-desk',
  '24-hour-security' = '24-hour-security',
  'accessible-parking' = 'accessible-parking',
  'access-to-healthcare-professionals' = 'access-to-healthcare-professionals',
  'aerobics' = 'aerobics',
  'air-conditioning' = 'air-conditioning',
  'airport-shuttle' = 'airport-shuttle',
  'all-inclusive-meals' = 'all-inclusive-meals',
  'all-rooms-disinfected-daily' = 'all-rooms-disinfected-daily',
  'archery' = 'archery',
  'atm-on-site' = 'atm-on-site',
  'audio-visual-equipment-rental' = 'audio-visual-equipment-rental',
  'auditory-guidance' = 'auditory-guidance',
  'baby-safety-gates' = 'baby-safety-gates',
  'babysitting-child-services' = 'babysitting-child-services',
  'badminton' = 'badminton',
  'baggage-storage' = 'baggage-storage',
  'banquet-rooms' = 'banquet-rooms',
  'bar' = 'bar',
  'bar-crawls' = 'bar-crawls',
  'bathhouse' = 'bathhouse',
  'bathroom-emergency-pull-cord' = 'bathroom-emergency-pull-cord',
  'bbq-facilities' = 'bbq-facilities',
  'beach' = 'beach',
  'beach-chairs-loungers' = 'beach-chairs-loungers',
  'beachfront' = 'beachfront',
  'beach-umbrellas' = 'beach-umbrellas',
  'beauty-services' = 'beauty-services',
  'bicycle-rental' = 'bicycle-rental',
  'bike-tours' = 'bike-tours',
  'billiards-pool-table' = 'billiards-pool-table',
  'bingo' = 'bingo',
  'board-games-puzzles' = 'board-games-puzzles',
  'boating' = 'boating',
  'body-thermometer' = 'body-thermometer',
  'books-dvds-music-for-kids' = 'books-dvds-music-for-kids',
  'bottled-water' = 'bottled-water',
  'bowling' = 'bowling',
  'breakfast-buffet' = 'breakfast-buffet',
  'breakfast-in-the-room' = 'breakfast-in-the-room',
  'breakfast-takeaway-containers' = 'breakfast-takeaway-containers',
  'business-center' = 'business-center',
  'buzzer-wireless-intercom' = 'buzzer-wireless-intercom',
  'canoeing' = 'canoeing',
  'carbon-monoxide-detector' = 'carbon-monoxide-detector',
  'carbon-monoxide-sources' = 'carbon-monoxide-sources',
  'car-for-hire' = 'car-for-hire',
  'car-rental' = 'car-rental',
  'cashless-payment-accepted' = 'cashless-payment-accepted',
  'casino' = 'casino',
  'cctv-in-common-areas' = 'cctv-in-common-areas',
  'cctv-outside-property' = 'cctv-outside-property',
  'chapel' = 'chapel',
  'chocolate-cookies' = 'chocolate-cookies',
  'cleaning-chemicals-used-are-effective-agaist-covid' = 'cleaning-chemicals-used-are-effective-agaist-covid',
  'coffee-shop' = 'coffee-shop',
  'common-areas-disinfected-daily' = 'common-areas-disinfected-daily',
  'common-stationery-removed' = 'common-stationery-removed',
  'concierge' = 'concierge',
  'contactless-check-in-check-out' = 'contactless-check-in-check-out',
  'breakfast-continental' = 'breakfast-continental',
  'cooking-class' = 'cooking-class',
  'couples-only' = 'couples-only',
  'cycling' = 'cycling',
  'daily-housekeeping' = 'daily-housekeeping',
  'darts' = 'darts',
  'delivered-food-covered-securely' = 'delivered-food-covered-securely',
  'designated-smoking-area' = 'designated-smoking-area',
  'diving' = 'diving',
  'doorman' = 'doorman',
  'dry-cleaning' = 'dry-cleaning',
  'electric-vehicle-charging-station' = 'electric-vehicle-charging-station',
  'elevator' = 'elevator',
  'entertainment-staff' = 'entertainment-staff',
  'evening-entertainment' = 'evening-entertainment',
  'express-check-in-check-out' = 'express-check-in-check-out',
  'exterior-corridor' = 'exterior-corridor',
  'face-masks-available-for-guests' = 'face-masks-available-for-guests',
  'face-masks-on-staff' = 'face-masks-on-staff',
  'facilities-for-disabled-guests' = 'facilities-for-disabled-guests',
  'family-rooms' = 'family-rooms',
  'fax-services' = 'fax-services',
  'fire-extinguishers' = 'fire-extinguishers',
  'fireplace' = 'fireplace',
  'first-aid-kits' = 'first-aid-kits',
  'fishing' = 'fishing',
  'fitness-center' = 'fitness-center',
  'food-can-be-delivered-for-in-room-dining' = 'food-can-be-delivered-for-in-room-dining',
  'food-delivery' = 'food-delivery',
  'foot-bath' = 'foot-bath',
  'foreign-currency-exchange' = 'foreign-currency-exchange',
  'breakfast-free' = 'breakfast-free',
  'fruit' = 'fruit',
  'game-room' = 'game-room',
  'garden' = 'garden',
  'gift-shop' = 'gift-shop',
  'golf-course-on-site' = 'golf-course-on-site',
  'golf-course-within-3-5-km-2-mi' = 'golf-course-within-3-5-km-2-mi',
  'grocery-deliveries' = 'grocery-deliveries',
  'guest-accommodations-disinfected-between-stays' = 'guest-accommodations-disinfected-between-stays',
  'guest-accommodations-sealed-after-cleaning' = 'guest-accommodations-sealed-after-cleaning',
  'guest-accommodation-cleaning-can-be-cancelled' = 'guest-accommodation-cleaning-can-be-cancelled',
  'guest-health-checks' = 'guest-health-checks',
  'guest-parking' = 'guest-parking',
  'guests-can-opt-out-of-daily-room-cleaning' = 'guests-can-opt-out-of-daily-room-cleaning',
  'hair-beauty-salon' = 'hair-beauty-salon',
  'restaurant-halal' = 'restaurant-halal',
  'hand-sanitizer-provided' = 'hand-sanitizer-provided',
  'happy-hour' = 'happy-hour',
  'heating' = 'heating',
  'hiking' = 'hiking',
  'honeymoon-bridal-suite' = 'honeymoon-bridal-suite',
  'horseback-riding' = 'horseback-riding',
  'hot-spring-bath' = 'hot-spring-bath',
  'hot-tub' = 'hot-tub',
  'hygiene-certification' = 'hygiene-certification',
  'hypoallergenic-rooms' = 'hypoallergenic-rooms',
  'indoor-play-area' = 'indoor-play-area',
  'infirmary' = 'infirmary',
  'internet' = 'internet',
  'invoices' = 'invoices',
  'ironing-service' = 'ironing-service',
  'karaoke' = 'karaoke',
  'key-card-or-motion-controlled-electricity' = 'key-card-or-motion-controlled-electricity',
  'kid-friendly-buffet' = 'kid-friendly-buffet',
  'kids-club' = 'kids-club',
  'kids-meals' = 'kids-meals',
  'kids-tv-channels' = 'kids-tv-channels',
  'restaurant-kosher' = 'restaurant-kosher',
  'laundry-service' = 'laundry-service',
  'library' = 'library',
  'linens-towels-laundry-washed-per-local-authority-guidelines' = 'linens-towels-laundry-washed-per-local-authority-guidelines',
  'live-music-performance' = 'live-music-performance',
  'live-sports-events-broadcast' = 'live-sports-events-broadcast',
  'local-safety-protocols-followed' = 'local-safety-protocols-followed',
  'locker-rooms' = 'locker-rooms',
  'lockers' = 'lockers',
  'lounge' = 'lounge',
  'low-bathroom-sink' = 'low-bathroom-sink',
  'massage' = 'massage',
  'massage-chair' = 'massage-chair',
  'meeting-rooms' = 'meeting-rooms',
  'miniature-golf' = 'miniature-golf',
  'minimarket-convenience-store' = 'minimarket-convenience-store',
  'mobile-app-for-room-service' = 'mobile-app-for-room-service',
  'movie-nights' = 'movie-nights',
  'newspapers' = 'newspapers',
  'nightclub-dj' = 'nightclub-dj',
  'no-children-allowed' = 'no-children-allowed',
  'non-smoking-rooms' = 'non-smoking-rooms',
  'open-air-bath' = 'open-air-bath',
  'fireplace-outdoor' = 'fireplace-outdoor',
  'outdoor-furniture' = 'outdoor-furniture',
  'outdoor-play-equipment' = 'outdoor-play-equipment',
  'personal-trainer' = 'personal-trainer',
  'photocopying-services' = 'photocopying-services',
  'physical-distancing-in-dining-areas' = 'physical-distancing-in-dining-areas',
  'physical-distancing-rules' = 'physical-distancing-rules',
  'picnic-area' = 'picnic-area',
  'playground' = 'playground',
  'pool-beach-towels' = 'pool-beach-towels',
  'portable-wi-fi-device-rental' = 'portable-wi-fi-device-rental',
  'postal-service' = 'postal-service',
  'prepared-lunches' = 'prepared-lunches',
  'printer' = 'printer',
  'beach-area-private' = 'beach-area-private',
  'private-check-in-check-out' = 'private-check-in-check-out',
  'property-cleaned-by-professional-cleaning-companies' = 'property-cleaned-by-professional-cleaning-companies',
  'property-has-wheelchair-access' = 'property-has-wheelchair-access',
  'public-transit-tickets' = 'public-transit-tickets',
  'racquetball-squash' = 'racquetball-squash',
  'raised-toilet' = 'raised-toilet',
  'refillable-water-stations' = 'refillable-water-stations',
  'restaurant' = 'restaurant',
  'room-service' = 'room-service',
  'safety-deposit-box' = 'safety-deposit-box',
  'safe-deposit-boxes-at-front-desk' = 'safe-deposit-boxes-at-front-desk',
  'sanitized-tableware' = 'sanitized-tableware',
  'sauna' = 'sauna',
  'screens-between-staff-guests-where-needed' = 'screens-between-staff-guests-where-needed',
  'security-alarm' = 'security-alarm',
  'self-service-laundry' = 'self-service-laundry',
  'shared-kitchen' = 'shared-kitchen',
  'shared-lounge-tv-area' = 'shared-lounge-tv-area',
  'shoeshine' = 'shoeshine',
  'shops-on-site' = 'shops-on-site',
  'shrine' = 'shrine',
  'shuttle-service' = 'shuttle-service',
  'single-use-plastics-removed' = 'single-use-plastics-removed',
  'ski-equipment-rental' = 'ski-equipment-rental',
  'skiing' = 'skiing',
  'ski-school' = 'ski-school',
  'smoke-alarms' = 'smoke-alarms',
  'smoke-free-property' = 'smoke-free-property',
  'snack-bar' = 'snack-bar',
  'snorkeling' = 'snorkeling',
  'solarium' = 'solarium',
  'soundproof-rooms' = 'soundproof-rooms',
  'spa' = 'spa',
  'special-diet-meals-on-request' = 'special-diet-meals-on-request',
  'stand-up-comedy' = 'stand-up-comedy',
  'steam-room' = 'steam-room',
  'sterilizing-equipment' = 'sterilizing-equipment',
  'strollers' = 'strollers',
  'suit-trouser-press' = 'suit-trouser-press',
  'sun-deck' = 'sun-deck',
  'surfing-lessons' = 'surfing-lessons',
  'swimming-pool' = 'swimming-pool',
  'table-tennis-ping-pong' = 'table-tennis-ping-pong',
  'taxi-service' = 'taxi-service',
  'temperature-check-for-guests-and-staff' = 'temperature-check-for-guests-and-staff',
  'temporary-art-galleries' = 'temporary-art-galleries',
  'tennis-court' = 'tennis-court',
  'terrace' = 'terrace',
  'themed-dinners' = 'themed-dinners',
  'theme-park' = 'theme-park',
  'thermometers-for-guests' = 'thermometers-for-guests',
  'ticketing-service' = 'ticketing-service',
  'toilet-with-grab-rails' = 'toilet-with-grab-rails',
  'tour-assistance' = 'tour-assistance',
  'tours' = 'tours',
  'towels-changed-upon-request' = 'towels-changed-upon-request',
  'turkish-steam-bath' = 'turkish-steam-bath',
  'room-service-24-hours' = 'room-service-24-hours',
  'valet-parking' = 'valet-parking',
  'valet-service' = 'valet-service',
  'vending-machine-drinks' = 'vending-machine-drinks',
  'vending-machine-snacks' = 'vending-machine-snacks',
  'vending-machines-contents-unspecified' = 'vending-machines-contents-unspecified',
  'vip-room-facilities' = 'vip-room-facilities',
  'visual-aids-braille' = 'visual-aids-braille',
  'visual-aids-tactile-signs' = 'visual-aids-tactile-signs',
  'walking-tours' = 'walking-tours',
  'water-park' = 'water-park',
  'waterslide' = 'waterslide',
  'water-sports-equipment-rental' = 'water-sports-equipment-rental',
  'water-sports-motorized' = 'water-sports-motorized',
  'water-sports-non-motorized' = 'water-sports-non-motorized',
  'welcome-drink' = 'welcome-drink',
  'windsurfing' = 'windsurfing',
  'wine-champagne' = 'wine-champagne',
  'yoga' = 'yoga',
}

export const amenityCategories = [
  'accessibility',
  'business-services',
  'check-in-front-desk-services',
  'common-areas',
  'cleaning-services',
  'entertainment-recreation',
  'environment-sustainability',
  'family-services-activities',
  'food-beverage',
  'general-guest-services',
  'parking-transportation',
  'pool-spa-wellness',
  'safety-security',
  'sanitation-hygiene-guest-health',
  'shopping',
  'additional-amenity',
] as const;

export type AmenityCategoryKeys = (typeof amenityCategories)[number];

export const amenityCategoryMap: Record<AmenityKeys, AmenityCategoryKeys> = {
  '24-hour-front-desk': 'check-in-front-desk-services',
  '24-hour-check-in': 'check-in-front-desk-services',
  'contactless-check-in-check-out': 'check-in-front-desk-services',
  'express-check-in-check-out': 'check-in-front-desk-services',
  invoices: 'check-in-front-desk-services',
  'private-check-in-check-out': 'check-in-front-desk-services',
  'air-conditioning': 'general-guest-services',
  internet: 'general-guest-services',
  'non-smoking-rooms': 'general-guest-services',
  'atm-on-site': 'general-guest-services',
  'baggage-storage': 'general-guest-services',
  concierge: 'general-guest-services',
  'couples-only': 'general-guest-services',
  'designated-smoking-area': 'general-guest-services',
  elevator: 'general-guest-services',
  'foreign-currency-exchange': 'general-guest-services',
  heating: 'general-guest-services',
  'honeymoon-bridal-suite': 'general-guest-services',
  'hypoallergenic-rooms': 'general-guest-services',
  lockers: 'general-guest-services',
  newspapers: 'general-guest-services',
  'room-service-24-hours': 'general-guest-services',
  'safe-deposit-boxes-at-front-desk': 'general-guest-services',
  'safety-deposit-box': 'general-guest-services',
  'smoke-free-property': 'general-guest-services',
  'soundproof-rooms': 'general-guest-services',
  'ticketing-service': 'general-guest-services',
  'tour-assistance': 'general-guest-services',
  'valet-service': 'general-guest-services',
  'vip-room-facilities': 'general-guest-services',
  'walking-tours': 'general-guest-services',
  'fitness-center': 'pool-spa-wellness',
  'hot-tub': 'pool-spa-wellness',
  sauna: 'pool-spa-wellness',
  spa: 'pool-spa-wellness',
  'swimming-pool': 'pool-spa-wellness',
  bathhouse: 'pool-spa-wellness',
  'beach-chairs-loungers': 'pool-spa-wellness',
  'beach-umbrellas': 'pool-spa-wellness',
  'beauty-services': 'pool-spa-wellness',
  'foot-bath': 'pool-spa-wellness',
  'hot-spring-bath': 'pool-spa-wellness',
  'locker-rooms': 'pool-spa-wellness',
  massage: 'pool-spa-wellness',
  'massage-chair': 'pool-spa-wellness',
  'open-air-bath': 'pool-spa-wellness',
  'personal-trainer': 'pool-spa-wellness',
  'pool-beach-towels': 'pool-spa-wellness',
  solarium: 'pool-spa-wellness',
  'steam-room': 'pool-spa-wellness',
  'turkish-steam-bath': 'pool-spa-wellness',
  waterslide: 'pool-spa-wellness',
  yoga: 'pool-spa-wellness',
  'water-park': 'entertainment-recreation',
  aerobics: 'entertainment-recreation',
  archery: 'entertainment-recreation',
  badminton: 'entertainment-recreation',
  'bar-crawls': 'entertainment-recreation',
  beach: 'entertainment-recreation',
  'beach-area-private': 'entertainment-recreation',
  beachfront: 'entertainment-recreation',
  'bike-tours': 'entertainment-recreation',
  'billiards-pool-table': 'entertainment-recreation',
  bingo: 'entertainment-recreation',
  boating: 'entertainment-recreation',
  bowling: 'entertainment-recreation',
  canoeing: 'entertainment-recreation',
  casino: 'entertainment-recreation',
  'cooking-class': 'entertainment-recreation',
  cycling: 'entertainment-recreation',
  darts: 'entertainment-recreation',
  diving: 'entertainment-recreation',
  'entertainment-staff': 'entertainment-recreation',
  'evening-entertainment': 'entertainment-recreation',
  fishing: 'entertainment-recreation',
  'golf-course-on-site': 'entertainment-recreation',
  'golf-course-within-3-5-km-2-mi': 'entertainment-recreation',
  'happy-hour': 'entertainment-recreation',
  hiking: 'entertainment-recreation',
  'horseback-riding': 'entertainment-recreation',
  karaoke: 'entertainment-recreation',
  'live-music-performance': 'entertainment-recreation',
  'live-sports-events-broadcast': 'entertainment-recreation',
  'miniature-golf': 'entertainment-recreation',
  'movie-nights': 'entertainment-recreation',
  'nightclub-dj': 'entertainment-recreation',
  'racquetball-squash': 'entertainment-recreation',
  'ski-equipment-rental': 'entertainment-recreation',
  'ski-school': 'entertainment-recreation',
  skiing: 'entertainment-recreation',
  snorkeling: 'entertainment-recreation',
  'stand-up-comedy': 'entertainment-recreation',
  'surfing-lessons': 'entertainment-recreation',
  'table-tennis-ping-pong': 'entertainment-recreation',
  'temporary-art-galleries': 'entertainment-recreation',
  'tennis-court': 'entertainment-recreation',
  'theme-park': 'entertainment-recreation',
  'themed-dinners': 'entertainment-recreation',
  tours: 'entertainment-recreation',
  'water-sports-motorized': 'entertainment-recreation',
  'water-sports-non-motorized': 'entertainment-recreation',
  'water-sports-equipment-rental': 'entertainment-recreation',
  windsurfing: 'entertainment-recreation',
  bar: 'food-beverage',
  restaurant: 'food-beverage',
  'room-service': 'food-beverage',
  'all-inclusive-meals': 'food-beverage',
  'bbq-facilities': 'food-beverage',
  'bottled-water': 'food-beverage',
  'breakfast-buffet': 'food-beverage',
  'breakfast-in-the-room': 'food-beverage',
  'breakfast-continental': 'food-beverage',
  'breakfast-free': 'food-beverage',
  'chocolate-cookies': 'food-beverage',
  'coffee-shop': 'food-beverage',
  'food-delivery': 'food-beverage',
  fruit: 'food-beverage',
  'grocery-deliveries': 'food-beverage',
  'kid-friendly-buffet': 'food-beverage',
  'kids-meals': 'food-beverage',
  'prepared-lunches': 'food-beverage',
  'restaurant-halal': 'food-beverage',
  'restaurant-kosher': 'food-beverage',
  'snack-bar': 'food-beverage',
  'special-diet-meals-on-request': 'food-beverage',
  'vending-machine-drinks': 'food-beverage',
  'vending-machine-snacks': 'food-beverage',
  'vending-machines-contents-unspecified': 'food-beverage',
  'welcome-drink': 'food-beverage',
  'wine-champagne': 'food-beverage',
  'airport-shuttle': 'parking-transportation',
  'guest-parking': 'parking-transportation',
  'baby-safety-gates': 'parking-transportation',
  'bicycle-rental': 'parking-transportation',
  'car-for-hire': 'parking-transportation',
  'car-rental': 'parking-transportation',
  'electric-vehicle-charging-station': 'parking-transportation',
  'public-transit-tickets': 'parking-transportation',
  'shuttle-service': 'parking-transportation',
  'taxi-service': 'parking-transportation',
  'valet-parking': 'parking-transportation',
  'family-rooms': 'family-services-activities',
  'kids-club': 'family-services-activities',
  'babysitting-child-services': 'family-services-activities',
  'board-games-puzzles': 'family-services-activities',
  'books-dvds-music-for-kids': 'family-services-activities',
  'indoor-play-area': 'family-services-activities',
  'kids-tv-channels': 'family-services-activities',
  'no-children-allowed': 'family-services-activities',
  'outdoor-play-equipment': 'family-services-activities',
  playground: 'family-services-activities',
  strollers: 'family-services-activities',
  garden: 'common-areas',
  terrace: 'common-areas',
  chapel: 'common-areas',
  'exterior-corridor': 'common-areas',
  fireplace: 'common-areas',
  'fireplace-outdoor': 'common-areas',
  'game-room': 'common-areas',
  library: 'common-areas',
  lounge: 'common-areas',
  'outdoor-furniture': 'common-areas',
  'picnic-area': 'common-areas',
  'shared-kitchen': 'common-areas',
  'shared-lounge-tv-area': 'common-areas',
  shrine: 'common-areas',
  'sun-deck': 'common-areas',
  'daily-housekeeping': 'cleaning-services',
  'dry-cleaning': 'cleaning-services',
  'ironing-service': 'cleaning-services',
  'laundry-service': 'cleaning-services',
  'self-service-laundry': 'cleaning-services',
  shoeshine: 'cleaning-services',
  'suit-trouser-press': 'cleaning-services',
  'audio-visual-equipment-rental': 'business-services',
  'banquet-rooms': 'business-services',
  'business-center': 'business-services',
  'fax-services': 'business-services',
  'meeting-rooms': 'business-services',
  'photocopying-services': 'business-services',
  'portable-wi-fi-device-rental': 'business-services',
  'postal-service': 'business-services',
  printer: 'business-services',
  'gift-shop': 'shopping',
  'hair-beauty-salon': 'shopping',
  'minimarket-convenience-store': 'shopping',
  'shops-on-site': 'shopping',
  'accessible-parking': 'accessibility',
  'auditory-guidance': 'accessibility',
  'bathroom-emergency-pull-cord': 'accessibility',
  'facilities-for-disabled-guests': 'accessibility',
  'low-bathroom-sink': 'accessibility',
  'property-has-wheelchair-access': 'accessibility',
  'raised-toilet': 'accessibility',
  'toilet-with-grab-rails': 'accessibility',
  'visual-aids-braille': 'accessibility',
  'visual-aids-tactile-signs': 'accessibility',
  '24-hour-security': 'safety-security',
  'buzzer-wireless-intercom': 'safety-security',
  'carbon-monoxide-detector': 'safety-security',
  'carbon-monoxide-sources': 'safety-security',
  'cctv-in-common-areas': 'safety-security',
  'cctv-outside-property': 'safety-security',
  doorman: 'safety-security',
  'fire-extinguishers': 'safety-security',
  'security-alarm': 'safety-security',
  'smoke-alarms': 'safety-security',
  'guests-can-opt-out-of-daily-room-cleaning': 'environment-sustainability',
  'key-card-or-motion-controlled-electricity': 'environment-sustainability',
  'refillable-water-stations': 'environment-sustainability',
  'single-use-plastics-removed': 'environment-sustainability',
  'towels-changed-upon-request': 'environment-sustainability',
  'access-to-healthcare-professionals': 'sanitation-hygiene-guest-health',
  'all-rooms-disinfected-daily': 'sanitation-hygiene-guest-health',
  'body-thermometer': 'sanitation-hygiene-guest-health',
  'breakfast-takeaway-containers': 'sanitation-hygiene-guest-health',
  'cashless-payment-accepted': 'sanitation-hygiene-guest-health',
  'cleaning-chemicals-used-are-effective-agaist-covid':
    'sanitation-hygiene-guest-health',
  'common-areas-disinfected-daily': 'sanitation-hygiene-guest-health',
  'common-stationery-removed': 'sanitation-hygiene-guest-health',
  'delivered-food-covered-securely': 'sanitation-hygiene-guest-health',
  'face-masks-available-for-guests': 'sanitation-hygiene-guest-health',
  'face-masks-on-staff': 'sanitation-hygiene-guest-health',
  'first-aid-kits': 'sanitation-hygiene-guest-health',
  'food-can-be-delivered-for-in-room-dining': 'sanitation-hygiene-guest-health',
  'guest-accommodation-cleaning-can-be-cancelled':
    'sanitation-hygiene-guest-health',
  'guest-accommodations-disinfected-between-stays':
    'sanitation-hygiene-guest-health',
  'guest-accommodations-sealed-after-cleaning':
    'sanitation-hygiene-guest-health',
  'guest-health-checks': 'sanitation-hygiene-guest-health',
  'hand-sanitizer-provided': 'sanitation-hygiene-guest-health',
  'hygiene-certification': 'sanitation-hygiene-guest-health',
  infirmary: 'sanitation-hygiene-guest-health',
  'linens-towels-laundry-washed-per-local-authority-guidelines':
    'sanitation-hygiene-guest-health',
  'local-safety-protocols-followed': 'sanitation-hygiene-guest-health',
  'mobile-app-for-room-service': 'sanitation-hygiene-guest-health',
  'physical-distancing-in-dining-areas': 'sanitation-hygiene-guest-health',
  'physical-distancing-rules': 'sanitation-hygiene-guest-health',
  'property-cleaned-by-professional-cleaning-companies':
    'sanitation-hygiene-guest-health',
  'sanitized-tableware': 'sanitation-hygiene-guest-health',
  'screens-between-staff-guests-where-needed':
    'sanitation-hygiene-guest-health',
  'sterilizing-equipment': 'sanitation-hygiene-guest-health',
  'temperature-check-for-guests-and-staff': 'sanitation-hygiene-guest-health',
  'thermometers-for-guests': 'sanitation-hygiene-guest-health',
};
